import { FC } from "react";

interface ToggleOnSVGProps {
    width?: number;
    height?: number;
}

const ToggleOnSVG: FC<ToggleOnSVGProps> = ({ width = "18px", height = "18px" }) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M16.0001 8.5C17.785 8.5 19.2779 9.86302 19.4641 11.6319C19.4898 11.8755 19.4898 12.1245 19.4641 12.3681C19.2779 14.137 17.785 15.5 16.0001 15.5C14.2153 15.5 12.7223 14.137 12.5361 12.3681C12.5105 12.1245 12.5105 11.8755 12.5361 11.6319C12.7223 9.86302 14.2153 8.5 16.0001 8.5Z" fill="#00086D" />
            <path fill-rule="evenodd" clip-rule="evenodd" d="M15.9258 5.25L8.07444 5.25C4.75295 5.25 1.92507 7.6664 1.40704 10.9473C1.29691 11.6448 1.29691 12.3552 1.40704 13.0528C1.92507 16.3336 4.75295 18.75 8.07445 18.75L15.9258 18.75C19.2473 18.75 22.0752 16.3336 22.5932 13.0527C22.7033 12.3552 22.7033 11.6448 22.5932 10.9473C22.0752 7.6664 19.2473 5.25 15.9258 5.25ZM15.9258 6.75C18.5092 6.75 20.7086 8.62942 21.1115 11.1812C21.1972 11.7237 21.1972 12.2763 21.1115 12.8188C20.7086 15.3706 18.5092 17.25 15.9258 17.25L8.07445 17.25C5.49106 17.25 3.2916 15.3706 2.88869 12.8188C2.80303 12.2763 2.80303 11.7237 2.88869 11.1812C3.2916 8.62943 5.49106 6.75 8.07444 6.75L15.9258 6.75Z" fill="#00086D" />
        </svg>
    );
};

export default ToggleOnSVG;
